module.exports = __webpack_public_path__ + "static/media/tecno_cel.a39a27b1.svg";